
// SVG Icon: next
export default { id: "terriajs-next" };
export const id = "terriajs-next";
export const name = "next";
